(ns hypnos.backoffice.tile.field.patient-key
  "Field for the (external) patient key."
  (:require [clojure.string :as str]
            [hypnos.graphql.queries :as queries]
            [hypnos.i18n :refer [tr]]
            [re-frame.core :as rf]))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; field

(defn field
  ([state]
   (field state {:disabled false}))
  ([state {:keys [disabled] :or {disabled false}}]
   (let [org (rf/subscribe [:backoffice/organization])]
     [:div.field.is-horizontal
      [:div.field-label.is-normal
       [:label.label (tr :ui.label/patient-key)]]
      [:div.field-body
       [:div.field
        [:p.control.is-expanded
         [:input.input
          {:type        :text
           :disabled    disabled
           :placeholder (when-not disabled (tr :ui.placeholder/patient-key))
           :value       (get-in @state [:patient :patient/key :value])
           :on-change   (fn [e]
                          (let [old-value (get-in @state [:patient :patient/key :value])
                                new-value (-> e .-target .-value)
                                changed?  (or (get-in @state [:patient :patient/key :dirty?])
                                              (not= new-value old-value))]
                            (swap! state assoc-in [:patient :patient/key :value] new-value)
                            (swap! state assoc-in [:patient :patient/key :dirty?] changed?)))
           :on-blur     (fn [_]
                          (swap! state assoc-in
                                 [:patient :patient/key :touched?]
                                 true))}]]
        (when-not disabled [:p.help (tr :ui.help/patient-key)])]
       (when-not disabled
         [:div.item
          [:button.button.is-success
           {:disabled (or (empty? (get-in @state [:patient :patient/key :value]))
                          (nil? (:organization/id @org)))
            :on-click (fn [_]
                        (let [org-id      (str (:organization/id @org))
                              patient-key (str/trim (get-in @state [:patient :patient/key :value]))]
                          (rf/dispatch [:amplify/query
                                        queries/get-patient-by-key
                                        {:key             patient-key
                                         :organization_id org-id}
                                        :backoffice/set-patient
                                        :backoffice/noop])
                          (swap! state assoc :patient-looked-up? true)
                          (swap! state assoc-in [:patient :patient/key] {:value    patient-key
                                                                         :dirty?   false
                                                                         :touched? false})))}
           [:span.icon [:i.mdi.mdi-account-search]]
           [:span (tr :ui.label/lookup)]]])]])))
